// Dependecies
import React from 'react';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import { withTranslation } from 'react-i18next';
// Hooks
import useLanguage from '../../hooks/useLanguage';

function Successfully({ img, t, setAlert, txt1, txt2, txt3, src }) {
  const { locale } = useLanguage();
  const history = useHistory();

  function redirect(route) {
    const url = `/${locale}/${route}`;
    history.push(url);
  }
  return (
    <div className="content_dynamic history block-job-requests">
      <Col lg={12} sm={12} className="content_not_mantenaice">
        <div className="modal-successfully center">
          <img src={img} className="img-not-maintenances" alt={t('alt:successfully')} />
          {txt2 !== '' && txt3 !== '' ? (
            <p className="txt-successfully center txt-16">
              {txt1} <strong>{txt2} </strong>
              {txt3}
            </p>
          ) : (
            <p className="txt-successfully center txt-16">{txt1}</p>
          )}

          <Button
            className="btn-orange"
            style={{ width: '250px', padding: '0px' }}
            variant="light"
            onClick={() => (src ? redirect(src) : setAlert(false))}
          >
            {t('btn-successfully')}
          </Button>
        </div>
      </Col>
    </div>
  );
}

Successfully.propTypes = {
  img: PropTypes.string,
  t: PropTypes.func.isRequired,
  setAlert: PropTypes.func.isRequired,
  txt1: PropTypes.string,
  txt2: PropTypes.string,
  txt3: PropTypes.string,
  src: PropTypes.string,
};

Successfully.defaultProps = {
  img: '',
  txt1: '',
  txt2: '',
  txt3: '',
  src: '',
};

export default withTranslation(['jobRequest', 'routers', 'alt'])(Successfully);
